import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const TOKEN_KEY = "peart_auth_token";
const TOKEN_EXPIRY_KEY = "peart_auth_token_expiry";

function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log('=== AuthCallback Component ===');
    console.log('Current URL:', window.location.href);
    console.log('Search params:', window.location.search);
    
    // Get tokens from query params
    const idToken = searchParams.get('id_token');
    const accessToken = searchParams.get('access_token');
    const expiresIn = searchParams.get('expires_in');
    const redirectUri = searchParams.get('redirect_uri') || '/admin';
    const error = searchParams.get('error');
    
    console.log('Tokens found:', { idToken: !!idToken, accessToken: !!accessToken, expiresIn, redirectUri });
    
    if (error) {
      console.error('OAuth error:', error);
      if (error === 'insufficient_permissions') {
        alert('Sie haben nicht die erforderlichen Berechtigungen für den Admin-Bereich.');
      }
      navigate('/login', { replace: true });
      return;
    }
    
    if (!idToken || !accessToken) {
      console.error('No tokens found in query params!');
      navigate('/login', { replace: true });
      return;
    }
    
    // Calculate expiry time
    const expiryTime = expiresIn 
      ? Date.now() + (parseInt(expiresIn) * 1000)
      : Date.now() + (60 * 60 * 1000); // Default 1 hour
    
    // Store tokens in localStorage
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(TOKEN_EXPIRY_KEY, expiryTime.toString());
    localStorage.setItem('oidc_id_token', idToken);
    
    console.log('Tokens stored successfully, redirecting to:', redirectUri);
    
    // Clear URL to hide tokens
    window.history.replaceState({}, document.title, '/oauth-redirect');
    
    // Navigate to the target page
    navigate(redirectUri, { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p>Authentifizierung wird verarbeitet...</p>
      </div>
    </div>
  );
}

export default AuthCallback;